export class Rol {
  ID: number;
  AplicacionID: number;
  Name: string;
  shortName: string;
  Description: string;
  Status: boolean;
  UserCreation: string;
  DateCreation: string;
  UserLastUpdate: string;
  DateLastUpdate: string;
  AplicacionName: string;
  StatusName: string;
}